import { hToggleArrayItem } from '@/utils/helpers';

import {
  FILL_GLOBAL_SETTINGS_DICTIONARY, TOGGLE_MENU,
  TOGGLE_LOADING, TOGGLE_MODAL, TOGGLE_PENDING_STORE_ACTIONS,
} from './mutation-types';

export default {
  [FILL_GLOBAL_SETTINGS_DICTIONARY](state, payload) {
    const _state = state;
    _state.globalSettings.dictionary = payload.dictionary;
  },

  [TOGGLE_MENU](state) {
    const _state = state;
    _state.isMenuExpanded = !_state.isMenuExpanded;
  },

  [TOGGLE_LOADING](state) {
    const _state = state;
    _state.isLoading = !_state.isLoading;
  },

  [TOGGLE_MODAL](state, payload) {
    const _state = state;
    _state.modal = payload.params;
  },

  [TOGGLE_PENDING_STORE_ACTIONS](state, payload) {
    const _state = state;
    _state.pendingStoreActions = hToggleArrayItem(_state.pendingStoreActions, payload);
  },

};
